import { Card, Container } from 'reactstrap';
import { StudentsRemovalRequestPendingDetailsLoader } from './StudentsRemovalRequestPendingDetailsLoader';
import { StudentsRemovalRequestPendingForm } from './StudentsRemovalRequestPendingForm';
import { StudentsRemovalRequestPendingSummary } from './StudentsRemovalRequestPendingSummary';

export function StudentsRemovalRequestPendingDetails() {
  return (
    <StudentsRemovalRequestPendingDetailsLoader>
      {({ data }) => (
        <Container fluid>
          <Card className="px-3 py-4">
            <StudentsRemovalRequestPendingSummary data={data} />
            <StudentsRemovalRequestPendingForm
              studentRemovalRequestId={data.studentRemovalRequest.id}
              studentStatus={data.studyPlanEnrollment.status}
            />
          </Card>
        </Container>
      )}
    </StudentsRemovalRequestPendingDetailsLoader>
  );
}
